import { gql } from 'apollo-angular';

export const GET_SERVICES = gql`
  query ($tenantId: ID!) {
    searchServices(tenantId: $tenantId) {
      id
      name
      category
      collectors {
        id
        name
      }
    }
  }
`;
